import {
  CircularProgress,
  Flex,
  Progress,
  Text,
  useToken,
} from "@chakra-ui/react";

type Props = {
  size?: string;
  color?: string;
  thickness?: string;
  loadingText?: string;
  w?: string;
  parentW?: string;
};

export const Loader = ({
  size = "160px",
  thickness = "3px",
  color = "blue.400",
  loadingText = "",
  w = "25%",
  parentW = "",
}: Props) => {
  const [accentColor] = useToken("colors", ["accentColor"]);

  return (
    <Flex
      direction={"column"}
      alignItems="center"
      justifyContent="center"
      gap={5}
      w={parentW}
    >
      {loadingText !== "" && (
        <Text whiteSpace={"nowrap"} fontSize="md" userSelect={"none"}>
          {loadingText}
        </Text>
      )}
      <Progress w={w} isIndeterminate color={accentColor} size={"md"} />
    </Flex>
  );
  return (
    <Flex
      direction={"column"}
      alignItems="center"
      justifyContent="center"
      h="fit-content"
      gap={5}
    >
      <CircularProgress
        thickness={thickness}
        size={size}
        capIsRound={true}
        isIndeterminate
        color={color}
      />
      {loadingText !== "" && (
        <Text whiteSpace={"nowrap"} fontSize="md">
          {loadingText}
        </Text>
      )}
    </Flex>
  );
};
